import React from "react";
import {
  AppBar,
  Box,
  Container,
  Divider,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import { DarkModeOutlined, LightModeOutlined } from "@mui/icons-material";
import Footer from "./Footer";
import Card from "./Card";
import { ColorModeContext, tokens } from "../../theme";
import { useBranding } from "../../BrandingContext";

type ExternalAccessLayoutProps = {
  title: string;
  description: string;
};

const ExternalAccessLayout: React.FC<ExternalAccessLayoutProps> = ({ title, description }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = React.useContext(ColorModeContext);
  const branding = useBranding();
  const APPBAR_H = 64;

  return (
    <Box>
      <AppBar position="fixed" elevation={1} sx={{ bgcolor: colors.grey[800] }}>
        <Toolbar
          sx={{
            minHeight: { xs: 56, sm: APPBAR_H },
            px: 2,
            display: "grid",
            gridTemplateColumns: "1fr auto 1fr",
            alignItems: "center",
          }}
        >
          <Box />
          <Box
            sx={{
              justifySelf: "center",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <img
              alt="logo"
              src={
                theme.palette.mode === "dark"
                  ? branding?.logoWhite
                  : branding?.logo || require("../../branding-assets/v3biomed/logo.png")
              }
              style={{ height: "80px", objectFit: "contain", maxWidth: "100%" }}
            />
          </Box>
          <Box sx={{ justifySelf: "end" }}>
            <IconButton onClick={colorMode.toggleColorMode}>
              {theme.palette.mode === "dark" ? <LightModeOutlined /> : <DarkModeOutlined />}
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Toolbar sx={{ minHeight: { xs: 56, sm: APPBAR_H } }} />
      <Container
        maxWidth="sm"
        sx={{
          minHeight: { xs: "calc(100dvh - 56px)", sm: `calc(100dvh - ${APPBAR_H}px)` },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 4,
        }}
      >
        <Card
          sx={{
            width: "100%",
            p: 2,
            mb: 2,
            padding: "2rem",
            border: "1px solid",
            borderColor: colors.grey[600],
            borderRadius: "12px",
            backgroundColor: colors.grey[800],
          }}
        >
          <Typography variant="h4" fontWeight="bold" sx={{ display: "flex", alignItems: "center" }}>
            {title}
          </Typography>
          <Divider sx={{ mt: 1, mb: 1 }} />
          <Typography variant="body1" sx={{ marginBottom: "1rem" }}>
            {description}
          </Typography>
        </Card>
      </Container>

      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, borderTop: 5 }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default ExternalAccessLayout;
